import styled from 'styled-components';

export const ForgotPassForm = styled.form`
  input {
    margin-bottom: 24px;
  }

  button[type="submit"] {
    width: 100%;
  }

  h3 {
    font-size: 12px;
    margin-bottom: 24px;
    font-weight: normal;
    color: ${props => props.theme.colors.fontPrimary}
  }
`;
